module.exports = __webpack_public_path__ + "img/blog-3.acab3dc3.webp";